import { Suspense, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { styled } from '@mui/material';
import { useSelector } from 'react-redux';
import { AppFooter } from './index';
import routes from '../routes/routes';
import { AppRoutes } from '../routes/AppRoutes';

const PRIMARY_WIDTH = 72;
const SECONDARY_WIDTH = 200;

const ContentMain = styled('div', {
  shouldForwardProp: (prop) => prop !== 'drawerstate' && prop !== 'theme',
})(({ theme, drawerstate }) => ({
  flexGrow: 1,
  padding: '0px 0px',
  position: 'relative',
  // background: theme.palette.common.white,
  // boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.08)",
  // border: `1px solid ${theme.palette.grey[200]}`,
  marginTop: '64px',
  marginBottom: '0',
  marginLeft:
    window.innerWidth >= 1200
      ? PRIMARY_WIDTH + (drawerstate ? SECONDARY_WIDTH : 0)
      : 0,
  // height:"calc(100vh + 100vh)",
  minHeight: 'calc(100vh - 64px)',
  maxHeight: 'calc(100vh - 64px)',
  overflowY: 'auto',
  marginRight: '0',
  borderRadius: '0',
  transition: theme.transitions.create(
    ['margin-top', 'height', 'margin-left'],
    {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    },
  ),
}));

const AppContent = () => {
  const location = useLocation();
  const isSecondaryMenuOpen = useSelector((state) => state.secondaryMenu.isSecondaryMenuOpen);

  const [prevLoc, setPrevLoc] = useState('');

  useEffect(() => {
    setPrevLoc(location.pathname);
    if (location.pathname === prevLoc) {
      setPrevLoc('');
    }
  }, [location]);

  const user = localStorage.getItem('token');
  if (!user) {
    return <Navigate to={AppRoutes.AUTH.LOGIN} replace />;
  }

  return (
    <>
      <ContentMain className="bg-white" drawerstate={isSecondaryMenuOpen}>
        {/* <Suspense fallback={<BackgroundArea open={true} />}> */}
        <Suspense>
          <Routes>
            <Route>
              {routes.map((route, idx) => {
                return (
                  route.element && (
                    <Route
                      key={idx}
                      path={route.path}
                      element={<route.element />}
                    />
                  )
                );
              })}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </ContentMain>
      <AppFooter />
    </>
  );
};

export default AppContent;